/**
 * FidFusion — Global JavaScript
 * Minimal, no dependencies
 */

(function() {
  'use strict';

  // Sticky Header — hide on scroll down, show on scroll up
  const header = document.querySelector('.ff-header[data-sticky="true"]');
  if (header) {
    let lastScrollY = 0;
    let ticking = false;

    function updateHeader() {
      const currentScrollY = window.scrollY;

      if (currentScrollY > 100) {
        header.classList.add('is-scrolled');

        if (currentScrollY > lastScrollY && currentScrollY > 200) {
          header.classList.add('is-hidden');
        } else {
          header.classList.remove('is-hidden');
        }
      } else {
        header.classList.remove('is-scrolled');
        header.classList.remove('is-hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    }, { passive: true });
  }

  // Product page — thumbnail click image switching
  document.querySelectorAll('.ff-product__thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      const mainImg = document.getElementById('product-main-img');
      if (mainImg && this.dataset.imageUrl) {
        mainImg.src = this.dataset.imageUrl;
        mainImg.srcset = '';
        document.querySelectorAll('.ff-product__thumb').forEach(function(t) {
          t.classList.remove('is-active');
        });
        this.classList.add('is-active');
      }
    });
  });

  // Product page — variant selection
  const variantContainer = document.querySelector('.ff-product__variants');
  if (variantContainer) {
    const variants = JSON.parse(variantContainer.dataset.productVariants);
    const optionGroups = variantContainer.querySelectorAll('.ff-product__variant-options');

    optionGroups.forEach(function(group) {
      group.querySelectorAll('.ff-product__variant-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
          // Update selected state in this group
          group.querySelectorAll('.ff-product__variant-btn').forEach(function(b) {
            b.classList.remove('is-selected');
          });
          btn.classList.add('is-selected');

          // Get all selected options
          var selectedOptions = [];
          optionGroups.forEach(function(g) {
            var selected = g.querySelector('.ff-product__variant-btn.is-selected');
            if (selected) {
              selectedOptions.push(selected.dataset.value);
            }
          });

          // Find matching variant
          var matchedVariant = variants.find(function(v) {
            return v.options.every(function(opt, i) {
              return opt === selectedOptions[i];
            });
          });

          if (matchedVariant) {
            // Update hidden input
            var idInput = document.querySelector('input[name="id"]');
            if (idInput) idInput.value = matchedVariant.id;

            // Update price
            var priceEl = document.querySelector('.ff-product__price');
            if (priceEl) {
              var formattedPrice = (matchedVariant.price / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
              priceEl.textContent = formattedPrice;
            }

            // Update availability
            var addBtn = document.querySelector('.ff-product__add-to-cart');
            if (addBtn) {
              if (matchedVariant.available) {
                addBtn.disabled = false;
                addBtn.textContent = 'Add to Cart';
              } else {
                addBtn.disabled = true;
                addBtn.textContent = 'Sold Out';
              }
            }

            // Update URL
            var url = new URL(window.location);
            url.searchParams.set('variant', matchedVariant.id);
            window.history.replaceState({}, '', url);

            // Update main image if variant has an image
            if (matchedVariant.featured_image) {
              var mainImg = document.getElementById('product-main-img');
              if (mainImg) {
                var imgSrc = matchedVariant.featured_image.src;
                mainImg.src = imgSrc;
                mainImg.srcset = '';

                // Also update thumbnail active state
                document.querySelectorAll('.ff-product__thumb').forEach(function(t) {
                  t.classList.remove('is-active');
                  if (t.dataset.imageUrl && imgSrc.includes(t.dataset.imageUrl.split('?')[0].split('/').pop().split('_')[0])) {
                    t.classList.add('is-active');
                  }
                });
              }
            }
          }
        });
      });
    });
  }

  // Cart count update via fetch (after add-to-cart)
  document.querySelectorAll('form[action="/cart/add"]').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(form);

      var btn = form.querySelector('button[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding...';
        btn.style.opacity = '0.7';
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        credentials: 'same-origin'
      })
      .then(function(response) { return response.json(); })
      .then(function() {
        // Update cart count
        fetch('/cart.js')
          .then(function(r) { return r.json(); })
          .then(function(cart) {
            const countEl = document.getElementById('cart-count');
            if (countEl) {
              countEl.textContent = cart.item_count;
            }
            // Brief confirmation
            if (btn) {
              btn.textContent = 'Added!';
              btn.style.background = '#2e7d32';
              btn.style.opacity = '1';
              setTimeout(function() {
                btn.textContent = originalText;
                btn.style.background = '';
                btn.disabled = false;
              }, 1500);
            }
          });
      })
      .catch(function(err) {
        console.error('Cart error:', err);
        if (btn) {
          btn.textContent = originalText;
          btn.style.opacity = '1';
          btn.disabled = false;
        }
        // Fallback: submit normally
        form.submit();
      });
    });
  });

})();
